import IIdentity from '../models/IdentityInterface';
import * as queryString from 'query-string';

export function isAuthenticated() {
  const token: any = queryString.parse(window.location.hash);
  if (token.access_token){
    accesToken = token.access_token;
    idToken = token.id_token;
    const base64AccessToken = token.access_token.split('.')[1];
    identity = JSON.parse(window.atob(base64AccessToken));
    isAdmin = identity['nxt:user:roles'] && identity['nxt:user:roles'].includes(3);
    isAssetManager = identity['nxt:user:roles'] && identity['nxt:user:roles'].includes(16);
    isBillingAdmin = identity['nxt:user:roles'] && identity['nxt:user:roles'].includes(20);
  }
  return !!token.access_token;
}

export function logout() {
  const logoutUrl = process.env.REACT_APP_LOGOUT_ENDPOINT;
  const redirectUri = process.env.REACT_APP_APPLICATION_ROOT;
  const url = encodeURI(logoutUrl as string) + "?id_token_hint=" + encodeURI(idToken as string) + "&post_logout_redirect_uri=" + encodeURI(redirectUri as string);
  window.open(url, '_self');
}

export function login() {
  const authorizationUrl = process.env.REACT_APP_AUTHORIZATION_ENDPOINT;
  const clientId = process.env.REACT_APP_CLIENT_ID;
  const redirectUri = process.env.REACT_APP_APPLICATION_ROOT + 'logincallback';
  const responseType = "id_token token";
  const scope: string = "openid";
  const nonce = Date.now() + "" + Math.random();
  
  let url = 
    encodeURI(authorizationUrl as string) + 
    "?client_id=" + encodeURI(clientId as string) + 
    "&redirect_uri=" + encodeURI(redirectUri) + 
    "&response_type=" + encodeURI(responseType) + 
    "&scope=" + encodeURI(scope) + "&" + 
    "&nonce=" + encodeURI(nonce) +
    '&state=' + encodeURIComponent(window.location.pathname + window.location.search);

  const queryParametersAsObject = queryString.parse(window.location.search);
  if (queryParametersAsObject.nxtCommunity) {
    url += '&nxtCommunity=' + queryParametersAsObject.nxtCommunity;
  }
  window.location.assign(url);
}

export let accesToken: string;
export let idToken: string;
export let identity: IIdentity;
export let isAdmin: boolean;
export let isAssetManager: boolean;
export let isBillingAdmin: boolean;


// WEBPACK FOOTER //
// ./src/modules/core/auth/identityAuth.tsx